/* Paw Wunschliste — window.Wishlist als Single Source of Truth.
   Persistenz: localStorage (ueberlebt Tab-/Browser-Schliessen und Neustarts;
   Grenzen: "Website-Daten loeschen" und privates Surfen, pro Geraet).
   UI-Vertrag:
   - [data-wishlist-toggle][data-handle]  Herz-Buttons (Karte/PDP), Klick toggelt;
     .is-active + aria-pressed werden synchron gehalten.
   - [data-wishlist-count]                Header-Badge (leer bei 0 -> :empty-CSS).
   - Event 'wishlist:updated' (detail.list) nach jeder Aenderung;
     'storage'-Event synct andere offene Tabs. */
(function () {
  'use strict';

  var KEY = 'paw:wishlist';

  function read() {
    try {
      var v = JSON.parse(window.localStorage.getItem(KEY));
      return Array.isArray(v) ? v : [];
    } catch (e) { return []; }
  }

  function write(list) {
    try { window.localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { list: list } }));
  }

  window.Wishlist = {
    list: read,
    count: function () { return read().length; },
    has: function (handle) { return read().indexOf(handle) !== -1; },
    toggle: function (handle) {
      if (!handle) return false;
      var l = read();
      var i = l.indexOf(handle);
      if (i === -1) l.unshift(handle); else l.splice(i, 1);
      write(l);
      return i === -1;
    },
    remove: function (handle) {
      var l = read();
      var i = l.indexOf(handle);
      if (i !== -1) { l.splice(i, 1); write(l); }
    }
  };

  function syncButtons(scope) {
    var btns = (scope || document).querySelectorAll('[data-wishlist-toggle]');
    var l = read();
    for (var i = 0; i < btns.length; i++) {
      var on = l.indexOf(btns[i].getAttribute('data-handle')) !== -1;
      btns[i].classList.toggle('is-active', on);
      btns[i].setAttribute('aria-pressed', on ? 'true' : 'false');
      var lbl = on ? btns[i].getAttribute('data-label-remove') : btns[i].getAttribute('data-label-add');
      if (lbl) btns[i].setAttribute('aria-label', lbl);
    }
  }

  function syncBadge() {
    var els = document.querySelectorAll('[data-wishlist-count]');
    var c = read().length;
    for (var i = 0; i < els.length; i++) {
      els[i].textContent = c > 0 ? String(c) : '';
    }
  }

  /* Delegiert: funktioniert auch fuer nachgeladene Karten (Karussells,
     Infinite Scroll, Wunschlisten-Seite). preventDefault stoppt die
     Navigation, falls ein Herz ueber einem Karten-Link liegt. */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-wishlist-toggle]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    window.Wishlist.toggle(btn.getAttribute('data-handle'));
  });

  document.addEventListener('wishlist:updated', function () { syncButtons(); syncBadge(); });
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) { syncButtons(); syncBadge(); }
  });
  window.addEventListener('pageshow', function () { syncButtons(); syncBadge(); });

  /* Fuer dynamisch eingefuegte Inhalte (z.B. Wunschlisten-Seite) */
  window.WishlistUI = { sync: function (scope) { syncButtons(scope); syncBadge(); } };

  function init() { syncButtons(); syncBadge(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
